// 챗봇 위젯(AssistantWidget) ↔ 차량 상세 패널(CarPanel) 창구.
//  - 위젯이 /assistant/config 를 받으면 setConfig → 패널이 getConfig/onConfig 로 버튼 노출 여부를 안다.
//  - 패널이 ask({carId, carNo}) → 위젯이 onAsk 로 받아 열고 그 차량 기준으로 질문을 보낸다.
// window CustomEvent 사용 — 선례 'company-switched' (App.js, Dashboard.js). 전역 상태 라이브러리 없음.
var CFG_EVT = 'assistant-config';
var ASK_EVT = 'assistant-ask';
var cfg = { available: false, agentEnabled: false };

export function setConfig(c) {
  cfg = { available: !!(c && c.available), agentEnabled: !!(c && c.agentEnabled) };
  window.dispatchEvent(new CustomEvent(CFG_EVT, { detail: cfg }));
}

export function getConfig() { return cfg; }

function listen(evt, cb) {
  var h = function (e) { cb(e.detail); };
  window.addEventListener(evt, h);
  return function () { window.removeEventListener(evt, h); };
}

export function onConfig(cb) { return listen(CFG_EVT, cb); }

export function ask(d) {
  window.dispatchEvent(new CustomEvent(ASK_EVT, { detail: d }));
}

export function onAsk(cb) { return listen(ASK_EVT, cb); }

// 앱 ARB assistantCarQuestion 과 같은 문장 — 차량번호만 앞에 붙는다.
export function carQuestion(carNo) {
  return carNo + ' 차량이 지금 어느 단계인지, 막힌 게 있으면 이유와 다음에 할 일을 알려줘';
}
